import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorSpot1 } from 'autogen/design-tokens/tokens';
import type { ProductPosStockViewModel } from 'autogen/swagger/all';
import { PosStoreStockText } from 'autogen/translation-keys/trans-website-productstorestock';

const Wrapper = styled.div`
    color: ${ColorSpot1};
`;

export function PosStoreStock({ model: { stock } }: { model: ProductPosStockViewModel }): JSX.Element {
    const { t } = useTranslation();

    return <Wrapper>{t(PosStoreStockText, { stock })}</Wrapper>;
}

export default PosStoreStock;
